module.exports = __webpack_public_path__ + "img/will-financials.c70917e7.svg";